import React, { useContext, useState, ChangeEvent, useEffect } from 'react';
import { Grid, Box, Divider, Checkbox, FormControlLabel, IconButton, Button, Typography, RadioGroup, Radio, OutlinedInput, InputLabel, MenuItem, FormControl, ListItemText } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import { useStyles } from './style';
import TextWithToggle from './toggle';
// import SimpleDropdown from '../dropdown';
import { TimePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/en-gb';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { MentorshipPreferenceDetails } from '../../interfaces/Profile';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { AuthUser } from '../../interfaces/Contexts';
import { getMentorShipPreferenceSetting, postMentorShipPreferenceSetting } from '../../Utils/apiService';
import { enqueueSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import routes from '../../Utils/routes';

dayjs.extend(utc);
dayjs.extend(timezone);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const expertise = ['Project Management'];
const format = 'HH:mm';
const language = ['Tamil', 'English'];
const menteeType = ['Undergraduates', 'Postgraduates'];

const FormField: React.FunctionComponent = () => {
  const classes = useStyles();
  const {
    state: { user },
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const userData = user as AuthUser;
  const [daySelect, setDaySelect] = React.useState<string[]>([]);
  const [expertiseSelect, setExpertiseSelect] = React.useState<string[]>([]);
  const [languageSelect, setLanguageSelect] = React.useState<string[]>([]);
  const [menteeSelect, setMenteeSelect] = React.useState<string[]>([]);
  const [range, setRange] = useState<[Dayjs, Dayjs] | null>([dayjs('00:00:00.000Z', 'HH:mm'), dayjs('00:00:00.000Z', 'HH:mm')]);
  const [formData, setFormData] = useState<MentorshipPreferenceDetails>({
    accountId: userData.applicantId,
    mentorshipAvailabilityDays: '',
    mentorshipAvailabilityStarttime: '',
    mentorshipAvailabilityEndtime: '',
    areasofexpertisein: '',
    languages: '',
    typesOfMentees: '',
    preferredMethodOfCommunication: '',
    privacyShowMyEmail: false,
    privacyShowMyContactNumber: false,
  });
  const [state, setState] = React.useState({
    Email: false,
    SMS: false,
    Whatsapp: false,
  });
  const handleChangeCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };
  const handleChangeDays = (event: SelectChangeEvent<typeof daySelect>) => {
    const {
      target: { value },
    } = event;
    setDaySelect(typeof value === 'string' ? value.split(',') : value);
  };
  const handleChangeExpertise = (event: SelectChangeEvent<typeof expertiseSelect>) => {
    const {
      target: { value },
    } = event;
    setExpertiseSelect(typeof value === 'string' ? value.split(',') : value);
  };
  const handleChangeLanguage = (event: SelectChangeEvent<typeof languageSelect>) => {
    const {
      target: { value },
    } = event;
    setLanguageSelect(typeof value === 'string' ? value.split(',') : value);
  };
  const handleChangeMentee = (event: SelectChangeEvent<typeof menteeSelect>) => {
    const {
      target: { value },
    } = event;
    setMenteeSelect(typeof value === 'string' ? value.split(',') : value);
  };
  const convertTimeToISOStart = (timeStr: string): string => {
    const [hours, minutes] = timeStr.split(':');

    return `${hours}:${minutes}:00.000Z`;
  };
  const convertTimeToISOEnd = (timeStr: string): string => {
    const [hours, minutes] = timeStr.split(':');

    return `${hours}:${minutes}:00.000Z`;
  };
  const handleChangeTime = (times: [Dayjs | null, Dayjs | null] | null, timeStrings: [string, string] | string[]) => {
    if (times && times[0] && times[1]) {
      console.log(`Start: ${times[0].format(format)}, End: ${times[1].format(format)}`);
      const isoTimeStart = convertTimeToISOStart(`${times[0].format(format)}`);
      const isoTimeEnd = convertTimeToISOEnd(`${times[1].format(format)}`);
      setFormData({ ...formData, mentorshipAvailabilityStarttime: isoTimeStart, mentorshipAvailabilityEndtime: isoTimeEnd });
      setRange(times as [Dayjs, Dayjs]);
    }
  };
  const handleChangeForm = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    console.log('Toggle Name:', name, 'Value:', checked);

    setFormData((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };
  const formatPersonName = (names: string[]): string => {
    return names?.map((name) => name.charAt(0).toUpperCase() + name.slice(1)).join(';');
  };
  const handleSave = () => {
    const daysSelect = formatPersonName(daySelect);
    const expertise = formatPersonName(expertiseSelect);
    const languagesSelect = formatPersonName(languageSelect);
    const mentees = formatPersonName(menteeSelect);
    const preferCommunication = Object.keys(state)
      .filter((key) => state[key as keyof typeof state] === true)
      .join(';');
    const payload: any = {
      ...formData,
      mentorshipAvailabilityDays: daysSelect,
      areasofexpertisein: expertise,
      languages: languagesSelect,
      typesOfMentees: mentees,
      preferredMethodOfCommunication: preferCommunication,
    };
    console.log('payload344', payload);

    postMentorShipPreferenceSetting(payload)
      .then((res) => {
        if (res?.success) {
          enqueueSnackbar({
            message: 'Mentorship Preference Saved Sucessfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
          navigate(routes.mentorDetails);
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  };
  const getMentorshipPreferenceSettings = () => {
    getMentorShipPreferenceSetting(userData.applicantId)
      .then((res) => {
        console.log('346546544564', res);
        setFormData({
          accountId: userData.applicantId,
          mentorshipAvailabilityDays: res.AccountPreferencesDetails.Mentorship_Availability_Days__c,
          mentorshipAvailabilityStarttime: res.AccountPreferencesDetails.Mentorship_Availability_Start_Time__c,
          mentorshipAvailabilityEndtime: res.AccountPreferencesDetails.Mentorship_Availability_End_Time__c,
          areasofexpertisein: res.AccountPreferencesDetails.Areas_of_Expertise_In__c,
          languages: res.AccountPreferencesDetails.Languages__c,
          typesOfMentees: res.AccountPreferencesDetails.Types_of_Mentees__c,
          preferredMethodOfCommunication: res.AccountPreferencesDetails.Mentor_Preferred_method_of_communication__c,
          privacyShowMyEmail: res.AccountPreferencesDetails.Privacy_Show_my_Email__c,
          privacyShowMyContactNumber: res.AccountPreferencesDetails.Privacy_Show_my_contact_number__c,
        });
        const updatedState = {
          Email: false,
          SMS: false,
          Whatsapp: false,
        };
        const input: string = res.AccountPreferencesDetails.Mentor_Preferred_method_of_communication__c;

        input.split(';').forEach((key) => {
          console.log('key', key);

          const normalizedKey = key.trim();
          if (normalizedKey in updatedState) {
            updatedState[normalizedKey as keyof typeof updatedState] = true;
          }
        });

        setState(updatedState);
        const days = res.AccountPreferencesDetails.Mentorship_Availability_Days__c.split(';');
        setDaySelect(days);
        const expertise = res.AccountPreferencesDetails.Areas_of_Expertise_In__c.split(';');
        setExpertiseSelect(expertise);
        const languages = res.AccountPreferencesDetails.Languages__c.split(';');
        setLanguageSelect(languages);
        const mentee = res.AccountPreferencesDetails.Types_of_Mentees__c.split(';');
        setMenteeSelect(mentee);
        if (res.AccountPreferencesDetails.Mentorship_Availability_Start_Time__c || res.AccountPreferencesDetails.Mentorship_Availability_End_Time__c) {
          const startTime = dayjs(res.AccountPreferencesDetails.Mentorship_Availability_Start_Time__c, 'HH:mm');
          const endTime = dayjs(res.AccountPreferencesDetails.Mentorship_Availability_End_Time__c, 'HH:mm');
          setRange([startTime, endTime]);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getMentorshipPreferenceSettings();
  }, []);
  return (
    <>
      <Box className={classes.entireContainer} sx={{ p: 2 }}>
        <Typography sx={{ fontSize: '15px', p: 2, fontWeight: '500' }} textAlign="start">
          Set up your preferences
        </Typography>
        <Box className={`${classes.mentorForm} scrollbar-cusgray`}>
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <Grid container className={classes.sepContainer}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} textAlign="start">
                  <Typography className={classes.rightHeadings}>Mentorship Availability</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4.5} lg={4.5} xl={4.5}>
                  <Typography textAlign="start" className={classes.labelName} sx={{ marginBottom: { lg: '10px' } }}>
                    Choose days
                  </Typography>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel id="demo-multiple-checkbox-label" sx={{ fontSize: '12px' }}>
                      Select
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={daySelect}
                      onChange={handleChangeDays}
                      input={<OutlinedInput label="Select" />}
                      renderValue={(selected) => selected.join(', ')}
                      MenuProps={MenuProps}
                      size="small"
                      sx={{
                        backgroundColor: 'white',
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3061FF',
                        },
                        '.MuiSelect-select': {
                          fontSize: '12px',
                          height: '21px',
                        },
                      }}
                    >
                      {days?.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: 'transparent',
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: 'transparent',
                            },
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                            '&:active': {
                              backgroundColor: 'transparent',
                            },
                          }}
                        >
                          <Checkbox checked={daySelect.indexOf(name) > -1} />
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4.5} lg={4.5} xl={4.5}>
                  <Typography textAlign="start" className={classes.labelName} sx={{ marginBottom: { lg: '10px' } }}>
                    Choose available time
                  </Typography>
                  <TimePicker.RangePicker format={format} showSecond={false} value={range} onChange={handleChangeTime} style={{ height: '40px', width: '100%' }} size="small" />
                </Grid>
              </Grid>
              <Grid container className={classes.sepContainer}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} textAlign="start">
                  <Typography className={classes.rightHeadings}>Areas of Expertise</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={4.5} lg={4.5} xl={4.5}>
                  <Typography textAlign="start" className={classes.labelName} sx={{ marginBottom: { lg: '10px' } }}>
                    Select Expertise
                  </Typography>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel id="demo-multiple-checkbox-label">Select</InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={expertiseSelect}
                      onChange={handleChangeExpertise}
                      input={<OutlinedInput label="Select" />}
                      renderValue={(selected) => selected.join(', ')}
                      MenuProps={MenuProps}
                      size="small"
                      sx={{
                        backgroundColor: 'white',
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3061FF',
                        },
                        '.MuiSelect-select': {
                          fontSize: '12px',
                          height: '21px',
                        },
                      }}
                    >
                      {expertise?.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: 'transparent',
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: 'transparent',
                            },
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                            '&:active': {
                              backgroundColor: 'transparent',
                            },
                          }}
                        >
                          <Checkbox checked={expertiseSelect.indexOf(name) > -1} />
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4.5} lg={4.5} xl={4.5}>
                  <Typography textAlign="start" className={classes.labelName} sx={{ marginBottom: { lg: '10px' } }}>
                    Select Languages
                  </Typography>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel id="demo-multiple-checkbox-label">Select</InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={languageSelect}
                      onChange={handleChangeLanguage}
                      input={<OutlinedInput label="Select" />}
                      renderValue={(selected) => selected.join(', ')}
                      MenuProps={MenuProps}
                      size="small"
                      sx={{
                        backgroundColor: 'white',
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3061FF',
                        },
                        '.MuiSelect-select': {
                          fontSize: '12px',
                          height: '21px',
                        },
                      }}
                    >
                      {language?.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: 'transparent',
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: 'transparent',
                            },
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                            '&:active': {
                              backgroundColor: 'transparent',
                            },
                          }}
                        >
                          <Checkbox checked={languageSelect.indexOf(name) > -1} />
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container className={classes.sepContainer}>
                <Grid item xs={12} textAlign="start">
                  <Typography className={classes.rightHeadings}>MentorShip Preferences</Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={4.5} lg={4.5} xl={4.5}>
                  <Typography textAlign="start" className={classes.labelName} sx={{ marginBottom: { lg: '10px' } }}>
                    Types of Mentees
                  </Typography>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel id="demo-multiple-checkbox-label">Select</InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={menteeSelect}
                      onChange={handleChangeMentee}
                      input={<OutlinedInput label="Select" />}
                      renderValue={(selected) => selected.join(', ')}
                      MenuProps={MenuProps}
                      size="small"
                      sx={{
                        backgroundColor: 'white',
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#3061FF',
                        },
                        '.MuiSelect-select': {
                          fontSize: '12px',
                          height: '21px',
                        },
                      }}
                    >
                      {menteeType?.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: 'transparent',
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: 'transparent',
                            },
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                            '&:active': {
                              backgroundColor: 'transparent',
                            },
                          }}
                        >
                          <Checkbox checked={menteeSelect.indexOf(name) > -1} />
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography textAlign="start" className={classes.labelName} sx={{ marginBottom: { lg: '10px' } }}>
                    Preferred method of communication
                  </Typography>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', marginTop: '10px' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={state.Email}
                          onChange={handleChangeCheck}
                          name="Email"
                          sx={{
                            color: 'black',
                            '&.Mui-checked': {
                              color: '#3061FF',
                            },
                            '& .MuiSvgIcon-root': {
                              fontSize: '18px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'black',
                            },
                          }}
                        />
                      }
                      label={<Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Email</Typography>}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={state.SMS}
                          onChange={handleChangeCheck}
                          name="SMS"
                          sx={{
                            color: 'black',
                            '&.Mui-checked': {
                              color: '#3061FF',
                            },
                            '& .MuiSvgIcon-root': {
                              fontSize: '18px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'black',
                            },
                          }}
                        />
                      }
                      label={<Typography sx={{ fontSize: '12px', fontWeight: 500 }}>SMS</Typography>}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={state.Whatsapp}
                          onChange={handleChangeCheck}
                          name="Whatsapp"
                          sx={{
                            color: 'black',
                            '&.Mui-checked': {
                              color: '#3061FF',
                            },
                            '& .MuiSvgIcon-root': {
                              fontSize: '18px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'black',
                            },
                          }}
                        />
                      }
                      label={<Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Whatsapp</Typography>}
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid container className={classes.sepContainer}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} textAlign="start" sx={{ marginBottom: { lg: '10px' } }}>
                  <Typography className={classes.rightHeadings}>Privacy and confidentiality</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography textAlign="start" className={classes.labelName} sx={{ marginBottom: { lg: '10px' } }}>
                    Manage who can send your contact information
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextWithToggle toggleName={'Show my Email'} isChecked={formData.privacyShowMyEmail} handleToggleChange={handleToggleChange} name="privacyShowMyEmail" />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextWithToggle toggleName={'Show my contact number'} isChecked={formData.privacyShowMyContactNumber} handleToggleChange={handleToggleChange} name="privacyShowMyContactNumber" />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
        </Box>
        <hr style={{ border: '1px solid #E5E6EA' }} />
        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            sx={{
              background: 'white',
              color: '#373A45',
              fontSize: '12px',
              fontWeight: '500',
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: 'white',
              },
              '&:active': {
                backgroundColor: 'white',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              ml: 2,
              borderRadius: '6px',
              boxShadow: 'none',
              '&:hover': {
                boxShadow: 'none',
              },
              '&:active': {
                boxShadow: 'none',
              },
            }}
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Save</Typography>
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default FormField;
